module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-champagne-brushed-4051-panel.15b56915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-champagne-brushed-4051-panel.jpg
// module id = 1116
// module chunks = 37